<template>
    <vxe-column field="areaName" title="所属区域" min-width="150px" align="center"></vxe-column>
</template>

<script setup lang="ts">
</script>

<style>
</style>
